import React from "react";
import { Button } from "antd";

const AppButton = (props) => {
  return <Button {...props}>{props.children}</Button>;
};

export default AppButton;
